import { DataSource, Layout, Textbox, } from "@mcleod/components";

export abstract class AutogenLayoutLayoutLookup extends Layout {
    sourceLayoutLookup: DataSource;
    textboxLayoutName: Textbox;
    textboxModelName: Textbox;
}
